import React from 'react';
import Integrations from '../components/Integrations';
import Contact from '../components/Contact';
import '../styles/Integrations.css';

const IntegrationsPage: React.FC = () => {
  return (
    <>
      <Integrations />
      <Contact />
    </>
  );
};

export default IntegrationsPage;
